import { useCallback } from 'react';

import { DefaultTooltip } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid/context';

import { useContestsSubscriptionsState } from '../containers/ContestsSubscriptions/hooks/states';

import Configure from './Configure'
import Export from './Export'

export default function HeaderButtons() {
  const { store: { onExport }, handleRefresh } = useGrid()
  const { selectedFields, setSelectedFields, options, query } = useContestsSubscriptionsState()

  const handleConfigure = useCallback(selectedFields => {
    setSelectedFields(selectedFields)
    handleRefresh()
  }, [handleRefresh, setSelectedFields])

  const handleExport = useCallback(async credential => {
    const { fields, filterBy } = query
    await onExport({ fields, filterBy, credential })
  }, [onExport, query])

  return <>
    <DefaultTooltip content='Configure' side='top'>
      <Configure onUpdate={handleConfigure} selectedFields={selectedFields} options={options} />
    </DefaultTooltip>
    <DefaultTooltip content='Export' side='top'>
      <Export onExport={handleExport} />
    </DefaultTooltip>
  </>
}
